exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transport .list {\n  background-color: #fff;\n  padding: 0.15rem 0;\n  padding-bottom: 0;\n}\n.transport .list .item_deault {\n  height: 0.3rem;\n  width: 0.75rem;\n  border: 1px solid #c9c9cc;\n  border-radius: 2px;\n  text-align: center;\n  color: #58586E;\n  font-size: 0.12rem;\n  line-height: 0.3rem;\n  margin-left: 15px;\n  margin-bottom: 0.15rem;\n}\n.transport .list .item_selected {\n  color: #fff;\n  background: #7E60FF;\n  border: 1px solid #7E60FF;\n}\n.transport .input_title span {\n  color: #F23363;\n}\n", ""]);

// exports
